import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

//Common
import { Snackbar } from "../../common/VFX-UI";

//App
import { CountyViewModel } from "../../../viewModels";
import { CountyDto } from "../../../app/model/api/types/dto";
import countyApi from "../../../app/model/api/countyApi";
import CountyForm from "./CountyForm";
import { CountyContext } from "./CountyContainer";
import { EMPTY_GUID } from "../../../utility/constants/constants";
import { apiErrorMessage } from "../../../utility/lib/error";
import { CountyFormContainerProps } from "../../../types/county";
import { SnackbarState } from "../../../types";

export const CountyFormContainer: React.FC<CountyFormContainerProps> = (
  props
) => {
  const { onClose, onShowSuccess } = props;
  const countyContext = useContext(CountyContext);

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = countyContext?.id
    ? "County updated"
    : "New County added";

  const onShowErrorSnackbar = (errorMessage: string) => {
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });
  };

  const onCloseSnackbar = () => {
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });
  };

  const { status, mutate } = useMutation<void, Error, CountyDto>({
    mutationFn: async (payload: CountyDto) => {
      const response = await countyApi.save(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
  });

  const handleOnSubmit = async (values: CountyViewModel) => {
    const county: CountyDto = values.toDto();
    mutate(county);
  };

  let stateId =
    countyContext?.stateId !== null && countyContext?.stateId !== undefined
      ? [countyContext.stateId]
      : [];

  const initialValues = countyContext?.id
    ? new CountyViewModel(
        countyContext.data?.id ?? null,
        countyContext.data?.name ?? null,
        countyContext.data?.description ?? null,
        countyContext.data?.stateId !== null &&
        countyContext.data?.stateId !== undefined
          ? [countyContext.data?.stateId]
          : null,
        countyContext.data?.sortValue ?? null,
        countyContext.data?.isActive ?? null
      )
    : new CountyViewModel(EMPTY_GUID, "", "", stateId, 100, true);

  return (
    <>
      <CountyForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleOnSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
